import { signInWithPopup, signOut, User } from 'firebase/auth';
import { auth, googleProvider } from '../config/firebase';

export interface GoogleAuthResponse {
  user: User;
  accessToken?: string;
  idToken?: string;
}

export const signInWithGoogle = async (): Promise<GoogleAuthResponse> => {
  try {
    console.log('Starting Google sign-in...');
    console.log('Auth instance:', auth);
    console.log('Google provider:', googleProvider);
    
    const result = await signInWithPopup(auth, googleProvider);
    const user = result.user;
    
    console.log('Google sign-in successful:', user);
    
    // Get the ID token for backend verification if needed
    const idToken = await user.getIdToken();
    // console.log('idToken----',idToken);
    
    return {
      user,
      idToken
    };
  } catch (error: any) {
    console.error('Google sign-in error:', error);
    console.error('Error code:', error.code);
    console.error('Error message:', error.message);
    
    // Provide more specific error messages
    if (error.code === 'auth/configuration-not-found') {
      throw new Error('Google Sign-in is not properly configured. Please check Firebase Console settings.');
    } else if (error.code === 'auth/popup-blocked') {
      throw new Error('Popup was blocked. Please allow popups for this site.');
    } else if (error.code === 'auth/popup-closed-by-user') {
      throw new Error('Sign-in was cancelled.');
    }
    
    throw new Error(error.message || 'Failed to sign in with Google');
  }
};

export const signOutGoogle = async (): Promise<void> => {
  try {
    await signOut(auth);
    console.log('Google sign-out successful');
  } catch (error: any) {
    console.error('Google sign-out error:', error);
    throw new Error(error.message || 'Failed to sign out');
  }
};

export const getCurrentUser = (): User | null => {
  return auth.currentUser;
};

export const onAuthStateChanged = (callback: (user: User | null) => void) => {
  return auth.onAuthStateChanged(callback);
}; 